var map = {
	"./087.png": "afbe",
	"./1.png": "7b14",
	"./2.png": "5770",
	"./3.png": "d9f2",
	"./4.png": "7553",
	"./_hand.png": "a266",
	"./blue-circle.png": "c231",
	"./hand.png": "db7d",
	"./icon1.png": "abd3",
	"./icon2.png": "3aa9",
	"./icon3.png": "4214",
	"./icon4.png": "aaff",
	"./itel.png": "41be",
	"./new-tel.png": "5bae",
	"./nhanh-sangtao-camket.png": "b777",
	"./van-hoa-en.png": "e23b",
	"./van-hoa.png": "78f5",
	"./vision-pattern.png": "be27",
	"./vnpt.png": "8a98"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42f3";